import { inject } from '@angular/core';
import { UserService } from '@app/core/services/user.service';

export const IsSuperadminGuard = () => inject(UserService).userIsSuperadmin;
